import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const { t } = useLanguage();
  useEffect(() => {
    document.title = t("payment.cancelTitle");
  }, [t]);

  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle size={60} className="mx-auto text-slate-400" />
      <h1 className="mt-6 font-serif font-bold text-2xl sm:text-3xl text-slate-900">{t("payment.cancelTitle")}</h1>
      <p className="mt-4 text-slate-600 leading-relaxed">{t("payment.cancelBody")}</p>
      <Link to="/wiki">
        <Button className="mt-8 bg-slate-900 hover:bg-slate-800 text-white rounded-full px-7 h-11">
          {t("payment.backToWiki")}
        </Button>
      </Link>
    </div>
  );
}
